export const FORM_UI_REASONS = {
  unknownField: 'Unknown field',
  hiddenField:
    'Not shown in the form right now; check the current step and the selections that reveal it',
  userOnlyField:
    'Only the user can fill this in, directly in the form. Ask them to; never ask them to paste it into the chat.',
  invalidForm: 'form must be a JSON object of field values',
};

export const FORM_UI_PREVIEW_VALUES = {
  userOnlyField: 'Not applied, enter it in the form',
  unknownField: 'Unknown field, not applied',
  empty: 'None',
};
